"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * useWindowSize
 *
 * @returns {
 *  height: Int -  Current window height
 *  width: Int - Current window width
 *  isDesktop: Boolean - Current window width > 1070
 *  isMobile: Boolean - Current window width < 720
 *  isMobileSmall: Boolean - Current window width < 480
 *  isTablet: Boolean - Current window width between mobile and desktop breakpoints
 * }
 */
const useWindowSize = () => {
    const [height, setHeight] = (0, react_1.useState)(null);
    const [width, setWidth] = (0, react_1.useState)(null);
    const handleResize = () => {
        setHeight(window.innerHeight);
        setWidth(window.innerWidth);
    };
    (0, react_1.useEffect)(() => {
        handleResize(); // set initial size
        // add event listener for resize on mount
        window.addEventListener('resize', handleResize);
        // clean up listener after
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const isDesktop = width && width > 1070;
    const isMobile = width && width < 720;
    const isMobileSmall = width && width < 480;
    const isTablet = width && width >= 720 && width <= 1070;
    return {
        height,
        width,
        isDesktop,
        isMobile,
        isMobileSmall,
        isTablet,
    };
};
exports.default = useWindowSize;
